import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import ThemedBadge from 'view/common/badges/badges';
import * as grid from 'view/styles/grid';

const MENU_PADDING = token('space.600', '48px');
const BADGE_CONTAINER_FONT_SIZE = 10;

export const AvatarMenuContainer = styled.div`
    padding: 0 ${token('space.100', '8px')};
    /*
        Because the avatar component sets multiple levels
        of divs with display: flex or display: inline-flex,
        to get the right height we need to force it here.
     */
    height: ${grid.multiple(4.5).px};
`;

export const MenuItemBadge = styled(ThemedBadge)`
    float: right;
    margin-left: ${MENU_PADDING};
`;

export const BadgeContainer = styled.span`
    position: absolute;
    bottom: 0;
    right: 0;
    pointer-events: none;

    > div {
        font-size: ${BADGE_CONTAINER_FONT_SIZE}px;
    }
`;
